import type { LedgerEntry } from "../api/types";

// signedAmount renders an entry's amount with the right sign for an
// "outbound" perspective: gumball spends and season expiry are debits and
// should read as negative even though the wire amount is stored unsigned.
// Coin grants and manual adjustments keep their stored sign.
export function signedAmount(entry: LedgerEntry): string {
  const debit = entry.entry_type === "gumball_spend" || entry.entry_type === "season_expiry";
  const value = debit ? -Math.abs(entry.amount) : entry.amount;
  if (value > 0) {
    return `+${value}`;
  }
  return String(value);
}
